import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito indicadores específicos?',
  a: 'No, este plan funciona con cualquier sistema de señales o indicadores de IA que ya utilices, optimizando cuándo confías en ellos.'
}, {
  q: '¿Sirve para recuperar una cuenta quemada al 90%?',
  a: 'Sirve para salvar lo que queda y reconstruir desde una base sólida, pero su mayor valor es evitar que llegues a ese 90%.'
}, {
  q: '¿Cuánto tiempo toma leer el manual?',
  a: 'Está diseñado para lectura rápida. En 20 minutos tendrás las tácticas de emergencia listas.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-brand-bg" data-id="element-34">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-36">
          <h2 className="text-3xl sm:text-4xl mb-3 md:mb-4 px-2" data-id="element-37">
            PREGUNTAS FRECUENTES
          </h2>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-38">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-white/10 rounded-lg overflow-hidden bg-brand-surface" data-id="element-39">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between gap-4 p-4 sm:p-5 md:p-6 text-left hover:bg-white/5 transition-colors" data-id="element-40">
                <span className="font-display text-base sm:text-lg tracking-wide leading-snug" data-id="element-41">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-red transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" />
              </button>
              <AnimatePresence data-id="element-43">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-44">
                    <div className="px-4 sm:px-5 md:px-6 pb-5 md:pb-6 pt-2 text-sm md:text-base text-gray-400 leading-relaxed border-t border-white/5 mt-1" data-id="element-45">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};